import { public_base_url } from "@/store/urls/base_urls";

// Public per-tenant branding (no auth). GET /api/public/branding?company=<slug>
export const PUBLIC_BRANDING = public_base_url + "branding";
